import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class ValidationService {

  static passwordPattern = '(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#\$%\^&\*]))(?=.{8,20})';
  static emailPattern = '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$';
  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;
    if (password !== confirmPassword) {
      AC.get('confirmPassword').setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  static emailValidator(control) {
    if (control && control.value) {
      if (control.value.match(ValidationService.emailPattern)) {
        return null;
      } else {
        return { 'invalidEmailAddress': true };
      }
    }
  }

  static passwordValidator(control) {
    if (control && control.value) {
      if (control.value.match(ValidationService.passwordPattern)) {
        return null;
      } else {
        return { 'invalidPassword': true };
      }
    }
  }

  static isValidPassword(value) {
    if (value) {
      if (value.match(ValidationService.passwordPattern)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  static isValidEmail(value) {
    if (value) {
      if (value.match(ValidationService.emailPattern)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/validation/validation.service.ts